import { render, staticRenderFns } from "./DeudaCreate.vue?vue&type=template&id=3171c148&scoped=true"
import script from "./DeudaCreate.vue?vue&type=script&lang=js"
export * from "./DeudaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3171c148",
  null
  
)

export default component.exports